<template>
  <v-card flat height="100%">
    <v-card-title>
      <v-layout>
        <v-flex xs8 ma-2>KV-Abrechnungsgruppen</v-flex>
        <v-spacer></v-spacer>
        <v-flex xs2 ma-2>
          <v-btn block color="primary" @click="back">Zurück</v-btn>
        </v-flex>
        <v-flex xs2 ma-2>
          <v-btn block color="primary" @click="showforwardDialog">Weiter</v-btn>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text>
      <v-layout wrap>
        <v-flex xs12 md12 lg6 pa-1>
          <v-data-table
            :headers="headers"
            :items="abrechnungsgruppen"
            :sort-by="['name']"
            :sort-desc="[false]"
            disable-pagination
            hide-default-footer
          >
            <template v-slot:item.status="{ item }">
              <v-icon v-if="item.hasValidationErrors" color="red">mdi-alert-circle</v-icon>
              <v-icon v-if="!item.hasValidationErrors" color="green">mdi-checkbox-marked-circle</v-icon>
            </template>
            <template v-slot:item.behandlungsorte="{ item }">
              <v-list-item v-for="behandlungsort in item.behandlungsorte" :key="behandlungsort.id">
                {{behandlungsort.name}}
                <v-chip small class="ma-2">{{gueltigBehandlungsort(behandlungsort)}}</v-chip>
                <v-chip small class="ma-2">{{behandlungsort.bsnr}}</v-chip>
              </v-list-item>
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon class="pa-1" small @click="edit(item)">mdi-pencil</v-icon>
              <v-icon
                class="pa-1"
                small
                @click="remove(item)"
                v-if="!item.lizenzaenderung"
              >mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 md12 lg6 pa-1>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout wrap>
              <v-flex xs12 sm6 md6 pa-1>
                <v-text-field v-model="edited.name" label="Name"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-1>
                <v-text-field
                  v-model="edited.knappschaftsNummer"
                  label="Knappschaftsnummer"
                  :rules="rules.knappschaftsNummer"
                  :counter="6"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm12 md12 pa-1>
                <v-data-table
                  v-model="edited.behandlungsorte"
                  :headers="behandlungsortHeaders"
                  :items="possibleBehandlungsorte"
                  :single-select="false"
                  item-key="id"
                  show-select
                  selectable-key="selectable"
                >
                  <template v-slot:item.name="{ item }">
                    {{item.name}}
                    <v-chip small class="ma-2">{{gueltigBehandlungsort(item)}}</v-chip>
                    <v-chip small class="ma-2">{{item.bsnr}}</v-chip>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-spacer></v-spacer>
              <v-btn class="ma-2" color="error" @click="clear">Bearbeitung abbrechen</v-btn>
              <v-btn class="ma-2" color="primary" @click="save">Speichern</v-btn>
            </v-layout>
          </v-form>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-dialog v-model="forwardDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Privatpraxis</v-card-title>
        <v-card-text>{{forwardDialogText}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="forwardDialog = false">Nein</v-btn>
          <v-btn color="blue darken-1" text @click="forward">Ja</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Wollen Sie diesen Eintrag wirklich löschen?</v-card-title>
        <v-card-text>Das Löschen kann nicht wieder rückgängig gemacht werden</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteDialog = false">Abbrechen</v-btn>
          <v-btn color="blue darken-1" text @click="deleteGruppe">Löschen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import { mapState } from "vuex";
function trimObjectValues(obj) {
  if (obj !== undefined && obj !== null) {
    Object.keys(obj).map(k => {
      var value = obj[k];
      if (value !== undefined && value !== null && typeof value == "string") {
        obj[k] = value.trim();
      } else if (value !== undefined && value !== null) {
        trimObjectValues(value);
      }
    });
  }
}
function edited() {
  return {
    name: "",
    knappschaftsNummer: "",
    behandlungsorte: []
  };
}
export default {
  data() {
    return {
      forwardDialog: false,
      forwardDialogText: "",
      deleteDialog: false,
      deleteDialogText: "",
      deleteItem: null,
      valid: false,
      behandlungsortHeaders: [{ text: "Behandlungsort", value: "name" }],
      headers: [
        { text: "", value: "status", sortable: false },
        { text: "Name", value: "name" },
        { text: "Behandlungsorte", value: "behandlungsorte", sortbale: false },
        { text: "Aktionen", value: "action", sortable: false }
      ],
      rules: {
        knappschaftsNummer: [
          v =>
            v === undefined || v === null || v.length === 0
              ? true
              : v.length === 6 ||
                "Die Knappschaftsnummer muss 6 Ziffern lang sein",
          v =>
            v === undefined || v === null || v.length === 0
              ? true
              : new RegExp("^[0-9]+$").test(v) ||
                "Die LANR darf nur Ziffern enthalten"
        ]
      },
      edited: edited()
    };
  },
  computed: {
    ...mapState({
      abrechnungsgruppen: state =>
        state.current.bestellung.lizenz.kvAbrechnungsgruppen,
      process: state => state.current.process,
      license: state => state.current.bestellung.lizenz,
      praxisart: state => state.current.bestellung.praxisart
    }),
    possibleBehandlungsorte: function() {
      if (
        this.abrechnungsgruppen === undefined ||
        this.abrechnungsgruppen === null
      ) {
        return [];
      }
      const usedBehandlungsorte = this.abrechnungsgruppen
        .filter(gr => gr.id !== this.edited.id)
        .flatMap(gr => gr.behandlungsorte)
        .map(o => o.id);
      return this.license.behandlungsorte.filter(
        ort => !usedBehandlungsorte.includes(ort.id)
      );
    }
  },
  mounted: function() {
    if (
      this.$route.params.process != this.process ||
      this.license === undefined
    ) {
      this.$socket.sendObj({
        eventID:
          "de.t2med.lizenzomat.eventapi.usecase.order.BestellungRequestEvent",
        processId: this.$route.params.process,
        taskId: this.$route.params.task
      });
    }
    this.setDefaultBehandlungsort();
  },
  watch: {
    abrechnungsgruppen: function(nV, oV) {
      if (nV !== undefined && nV.length >= oV.length) {
        this.clear();
        this.setDefaultBehandlungsort();
      }
    }
  },
  methods: {
    gueltigBehandlungsort: function(behandlungsort) {
      if (behandlungsort.inaktiv) {
        return "inaktiv";
      } else {
        const monthDateFormat = { month: "2-digit", year: "numeric" };
        const dateFormat = {
          day: "2-digit",
          month: "2-digit",
          year: "numeric"
        };
        if (
          behandlungsort.aktivAb === null &&
          behandlungsort.aktivBis === null
        ) {
          return "aktiv";
        } else if (
          behandlungsort.aktivAb !== null &&
          behandlungsort.aktivBis === null
        ) {
          return (
            new Date(behandlungsort.aktivAb).toLocaleDateString(
              undefined,
              monthDateFormat
            ) + " - n. a."
          );
        } else if (
          behandlungsort.aktivAb === null &&
          behandlungsort.aktivBis !== null
        ) {
          return (
            "n. a. - " +
            new Date(behandlungsort.aktivBis).toLocaleDateString(
              undefined,
              dateFormat
            )
          );
        } else {
          return (
            new Date(behandlungsort.aktivAb).toLocaleDateString(
              undefined,
              monthDateFormat
            ) +
            " - " +
            new Date(behandlungsort.aktivBis).toLocaleDateString(
              undefined,
              monthDateFormat
            )
          );
        }
      }
    },
    setDefaultBehandlungsort: function() {
      if (
        this.abrechnungsgruppen === undefined ||
        this.abrechnungsgruppen === null
      ) {
        return [];
      }
      const usedBehandlungsorte = this.abrechnungsgruppen
        .flatMap(gr => gr.behandlungsorte)
        .map(o => o.id);
      const notUsedBehandlungsorte = this.license.behandlungsorte.filter(
        ort => !usedBehandlungsorte.includes(ort.id)
      );
      if (notUsedBehandlungsorte.length === 1) {
        if (
          (this.praxisart === "PRAXISGEMEINSCHAFT" &&
            this.abrechnungsgruppen.length >= 0) ||
          (this.praxisart !== "PRAXISGEMEINSCHAFT" &&
            this.abrechnungsgruppen.length < 1)
        ) {
          const behandlungsort = JSON.parse(
            JSON.stringify(notUsedBehandlungsorte[0])
          );
          this.edited.name = behandlungsort.name;
          this.edited.behandlungsorte = [behandlungsort];
        }
      }
    },
    edit: function(abrechnungsgruppe) {
      this.edited = JSON.parse(JSON.stringify(abrechnungsgruppe));
    },
    clear: function() {
      this.edited = edited();
      this.$refs.form.resetValidation();
    },
    behandlungsortName: function(behandlungsort) {
      return (
        behandlungsort.name +
        " (" +
        (behandlungsort.inaktiv ? "Inaktiv" : "Aktiv") +
        ")"
      );
    },
    save: function() {
      if (this.$refs.form.validate()) {
        this.$store.commit("startLoading");
        const toSave = this.edited;
        trimObjectValues(toSave);
        this.$socket.sendObj({
          eventID:
            "de.t2med.lizenzomat.eventapi.usecase.order.kvabrechnungsgruppe.KVAbrechnungsgruppeSaveRequestEvent",
          processId: this.$route.params.process,
          taskId: this.$route.params.task,
          kvAbrechnungsgruppe: toSave
        });
      }
    },
    remove: function(abrechnungsgruppe) {
      this.deleteItem = abrechnungsgruppe;
      this.deleteDialog = true;
    },
    deleteGruppe: function() {
      this.$store.commit("startLoading");
      this.$socket.sendObj({
        eventID:
          "de.t2med.lizenzomat.eventapi.usecase.order.kvabrechnungsgruppe.KVAbrechnungsgruppeDeleteRequestEvent",
        kvAbrechnungsgruppeId: this.deleteItem.id
      });
      this.deleteItem = null;
      this.deleteDialog = false;
    },
    back: function() {
      this.$store.commit("startLoading");
      this.$socket.sendObj({
        eventID:
          "de.t2med.lizenzomat.eventapi.usecase.order.BackwardRequestEvent",
        taskId: this.$route.params.task,
        processId: this.$route.params.process
      });
    },
    showforwardDialog: function() {
      const usedBehandlungsorte = this.abrechnungsgruppen
        .flatMap(gr => gr.behandlungsorte)
        .map(o => o.id);
      const notUsedBehandlungsorte = this.license.behandlungsorte.filter(
        ort =>
          !usedBehandlungsorte.includes(ort.id) &&
          !ort.bsnr.startsWith("9999999") &&
          ort.bsnr !== ""
      );
      if (
        this.abrechnungsgruppen.length <= 0 &&
        notUsedBehandlungsorte.length > 0
      ) {
        this.forwardDialog = true;
        this.forwardDialogText =
          "Es wurden keine KV-Abbrechnungsgruppen angegeben und es existieren Praxen mit BSNR die keiner KV-Abrechnungsgruppe zugeordnet sind. Die Praxis kann damit nur privat abrechnen. Im Normalfall ist das nicht korrekt und sollte überprüft werden. Trotzdem fortfahren?";
      } else if (this.abrechnungsgruppen.length <= 0) {
        this.forwardDialog = true;
        this.forwardDialogText =
          "Es wurden keine KV-Abbrechnungsgruppen angegeben, die Praxis kann damit nur privat abrechnen. Als reine Privatpraxis anlegen?";
      } else if (notUsedBehandlungsorte.length > 0) {
        this.forwardDialog = true;
        this.forwardDialogText =
          "Es sind Behandlungsorte vorhanden die keiner KV-Abrechnungsgruppe zugeordnet wurden. Im Normalfall ist das nicht korrekt und sollte überprüft werden. Trotzdem fortfahren?";
      } else {
        this.forward();
      }
    },
    forward: function() {
      this.forwardDialog = false;
      this.$store.commit("startLoading");
      this.$socket.sendObj({
        eventID:
          "de.t2med.lizenzomat.eventapi.usecase.order.kvabrechnungsgruppe.KVAbrechnungsgruppenContinueRequestEvent",
        processId: this.$route.params.process,
        taskId: this.$route.params.task
      });
    }
  }
};
</script>
